import React from "react";
import styled from "styled-components";

const stats = [
  { num: "4",      unit: "",     label: "Product Lines",   sub: "BOPP · POF · LD · HM" },
  { num: "Custom", unit: "",     label: "Print Available", sub: "Any design or plain" },
  { num: "Pan",    unit: "India",label: "Delivery",        sub: "Nationwide supply" },
];

const Section2 = () => (
  <SectionWrapper>
    {/* Stats strip */}
    <StatsStrip>
      {stats.map((s, i) => (
        <React.Fragment key={i}>
          <StatCell>
            <StatNumber>
              {s.num}
              {s.unit && <StatUnit>{s.unit}</StatUnit>}
            </StatNumber>
            <StatLabel>{s.label}</StatLabel>
            <StatSub>{s.sub}</StatSub>
          </StatCell>
          {i < stats.length - 1 && <StatDivider />}
        </React.Fragment>
      ))}
    </StatsStrip>

    {/* Company statement */}
    <StatementSection>
      <StatementTag>About Us</StatementTag>
      <StatementText>
        BR Plast is India's trusted manufacturer and trader of high-quality
        plastic packaging films — serving businesses across every industry
        with precision, reliability, and speed.
      </StatementText>
      <StatementBody>
        As a plastic manufacturing and trading company, we specialize in
        providing packaging solutions to meet the diverse needs of our
        customers. Whether you need custom-designed pouches or off-the-shelf
        options, we deliver on time to any business address across India.
      </StatementBody>
    </StatementSection>
  </SectionWrapper>
);

const SectionWrapper = styled.div`
  background: var(--color-bg);
`;

/* Stats strip */
const StatsStrip = styled.div`
  display: flex;
  align-items: stretch;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);

  @media (max-width: 768px) {
    flex-wrap: wrap;
  }
`;

const StatCell = styled.div`
  flex: 1;
  padding: 52px 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    flex: 0 0 50%;
    padding: 36px 28px;
    border-bottom: 1px solid var(--color-border);
  }
`;

const StatNumber = styled.div`
  font-size: 64px;
  font-weight: 900;
  color: var(--color-dark);
  line-height: 1;
  letter-spacing: -2px;
  display: flex;
  align-items: baseline;
  gap: 6px;
  font-family: var(--font-primary);

  @media (max-width: 768px) { font-size: 48px; }
`;

const StatUnit = styled.span`
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.5px;
  color: var(--color-muted);
`;

const StatLabel = styled.p`
  font-size: 13px;
  font-weight: 700;
  color: var(--color-dark);
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 12px 0 4px;
`;

const StatSub = styled.p`
  font-size: 13px;
  color: var(--color-muted);
  margin: 0;
`;

const StatDivider = styled.div`
  width: 1px;
  background: var(--color-border);
  flex-shrink: 0;

  @media (max-width: 768px) { display: none; }
`;

/* Statement section */
const StatementSection = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr 2fr;
  gap: 0;
  padding: 80px;
  border-bottom: 1px solid var(--color-border);
  align-items: start;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    padding: 48px 24px;
    gap: 16px;
  }
`;

const StatementTag = styled.span`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  color: var(--color-muted);
  padding-top: 6px;
`;

const StatementText = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: var(--color-dark);
  line-height: 1.35;
  margin: 0;
  letter-spacing: -0.5px;
  padding-right: 48px;

  @media (max-width: 900px) {
    font-size: 22px;
    padding-right: 0;
  }
`;

const StatementBody = styled.p`
  font-size: 16px;
  color: var(--color-muted);
  line-height: 1.8;
  margin: 0;
  padding-left: 48px;
  border-left: 1px solid var(--color-border);

  @media (max-width: 900px) {
    padding-left: 0;
    border-left: none;
    font-size: 15px;
  }
`;

export default Section2;
